import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import t1 from '../assets/defaultimage1.jpg';
import t2 from '../assets/defaultImage2.jpg';
import t3 from '../assets/defaultImage3.jpg';

const team = [
    { name: 'Alex Morgan', role: 'Founder / Lead Landscaper', img: t1 },
    { name: 'Jamie Lee', role: 'Design Specialist', img: t2 },
    { name: 'Chris Walker', role: 'Operations Manager', img: t3 }
];

const About = () => {
    return (
        <Container className="my-5">
            <Row>
                <Col>
                    <h1>About Nicer Lawns</h1>
                    <p className="text-muted">Locally owned and operated — providing trusted landscaping services with a focus on quality and customer satisfaction.</p>
                </Col>
            </Row>

            <Row className="mt-4">
                <Col md={6}>
                    <h4>Our Mission</h4>
                    <p className="text-muted">To create and maintain beautiful, sustainable outdoor spaces that enhance the value and enjoyment of every property we touch. We emphasize thoughtful design, responsible maintenance, and clear communication.</p>

                    <h4>Why Choose Us</h4>
                    <ul className="text-muted">
                        <li>Experienced, licensed landscaping professionals</li>
                        <li>Quality materials and workmanship</li>
                        <li>Transparent pricing and dependable scheduling</li>
                    </ul>
                </Col>
                <Col md={6}>
                    <h4>Our Story</h4>
                    <p className="text-muted">Started by a small team with a passion for outdoor design, Nicer Lawns has grown while keeping a commitment to personalized service and strong local relationships.</p>
                </Col>
            </Row>

            <Row className="mt-4">
                <Col>
                    <h3 className="mb-3">Meet the Team</h3>
                </Col>
            </Row>

            <Row>
                {team.map((t, i) => (
                    <Col key={i} md={4} className="mb-4">
                        <Card className="text-center shadow-sm p-3">
                            <Card.Img variant="top" src={t.img} style={{height:200, objectFit:'cover', borderRadius:8}} />
                            <Card.Body>
                                <Card.Title>{t.name}</Card.Title>
                                <Card.Text className="text-muted">{t.role}</Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
}

export default About;